import Phaser from 'phaser';
import Button from '~/components/buttons/Button';
import ScaleService from '~/services/ScaleService';
import UserService from '~/services/UserService';
import WalletConnectService from '~/services/WalletConnectService';
import { BR_GameOver_Scene_Assets } from '~/utils/AssetLoader';
import { LoadImageAssets, UnloadImages } from '~/utils/AssetManager';

const modalHeight = 701;
const modalWidth = 387;

export default class BattleRoyaleGameOverScene extends Phaser.Scene {
  private _scale;
  private _resultBadge;
  private _resultTitle;
  private _winnerLabel;
  private _text;
  private _returnHomeButton;
  private _viewResultsButton;
  private _participants;
  private _winner;
  private _isLocalWinner;
  private _badgeName;
  private _badgeTitle;
  private _winnerPFP;

  init(data: any) {
    this._participants = data.participants;
    //this._participants = [{"clientId":"id","playerId":"this is a big wallet id 0","playerName":"Player 0","playerImageKey":"nft_375138076","playerImageUrl":"https://lh3.googleusercontent.com/X0xX39ZHn98PWVfVCtZ4_A-uvWr6MkVImiNDQFGIodAGNF5Gabdeu2QjOXID5L5f5UV6pis7lDd5tDq2kYhvnMX34M1dn_SYTuuaBw","playerLevel":66,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":2,"kills":0,"evades":1,"lazes":0,"suicides":0},{"clientId":"id","playerId":"this is a big wallet id 1","playerName":"Player 1","playerImageKey":"nft_375137903","playerImageUrl":"https://lh3.googleusercontent.com/uXq7cKznuye2S2tSt8dmSCQWwiwU3jm0e_HRfcikaw8uFfJQW2FnUc6ocjLOy6phWqnNa8uMXzH4vDgX8XcUWzDRBeMsdLo7sbfwgR0","playerLevel":17,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":3,"kills":1,"evades":1,"lazes":0,"suicides":1},{"clientId":"id","playerId":"this is a big wallet id 2","playerName":"Player 2","playerImageKey":"nft_375138183","playerImageUrl":"https://lh3.googleusercontent.com/-WA4eCwPeqog1egAke21QqBE0HqpzadVvTRazDHtfzZkGSI2M3JICySt0dq7CQNMKAGaLahEUx9rgRAyRWTX9SG17iSKT_wj_aQK","playerLevel":92,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":4,"kills":0,"evades":0,"lazes":0,"suicides":0},{"clientId":"id","playerId":"this is a big wallet id 3","playerName":"Player 3","playerImageKey":"nft_373010558","playerImageUrl":"https://lh3.googleusercontent.com/_6dhMRaY-O4Fz0280tLVQTfy6IKhS1TB4eI4lY7LoMnVWPK2WYDf_5q6PsEEJwigcU0XC5Yk1G7RHEVfcasfk9X-7q2RB2JrjRNvdg","playerLevel":68,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":6,"kills":0,"evades":0,"lazes":0,"suicides":0},{"clientId":"id","playerId":"this is a big wallet id 4","playerName":"Luke","playerImageKey":"nft_375140812","playerImageUrl":"https://lh3.googleusercontent.com/WHqaIoTlifO5UYGJ-2tYcbk76hkGcx2WlQgCfqk6ATgE8HsAtKwzYgYXrIGb7OODrdRtn11M6zYjnFTS-C-84HHny8DIj9QWPfxr","playerLevel":44,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":1,"kills":2,"evades":2,"lazes":0,"suicides":0},{"clientId":"5iLxgWZR_","playerId":"0xA786bAED9d87aAa039C7C97B166A419d9F42eAa6","playerName":"Luke","playerImageKey":"nft_317575408","playerImageUrl":"https://lh3.googleusercontent.com/ySKhT1Qs2zVr9G8t6qd0oZj5PBVp0Jm5BJF8sPHEN-fA9QbykGe-E8Gb88YMvTetCSOzf42RYny8uErs6z4FRMO5b7AOzZBg0HuniA=s128","playerLevel":187,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":5,"kills":0,"evades":1,"lazes":0,"suicides":1}]
    this._winner = this.getWinner(this._participants);
    this._isLocalWinner = WalletConnectService.getInstance().getWalletAddress() === this._winner.playerId ? true : false;
    this._badgeName = this._isLocalWinner ? 'bossfight_victory_badge' : 'bossfight_defeat_badge';
    this._badgeTitle = this._isLocalWinner ? 'bossfight_victory_title' : 'bossfight_defeat_title';
  }

  constructor() {
    super({
      key: 'BattleRoyaleGameOverScene',
    });
  }

  preload() {
    LoadImageAssets(this, BR_GameOver_Scene_Assets);

    // Winning Player PFP
    this.load.image(this._winner.playerImageKey, this._winner.playerImageUrl);
  }

  create() {
    this._scale = ScaleService.getInstance().getScale(modalWidth, modalHeight);
    this.createComponent();
  }

  createComponent() {
    const background = this.add.rexRoundRectangle(
      0, // x
      0, // y
      this.sys.game.canvas.width * 2, // width
      this.sys.game.canvas.height * 2, // height
      0, // radius
      0x000000, // fillColor
      0.73, // alpha
    );

    this.add.existing(background);

    var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
      width: modalWidth * this._scale,
      height: modalHeight * this._scale,
      space: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        item: 0,
        line: 0,
      },
      align: 0,
      sizerEvents: true,
    });

    // Add Result Badge
    this._resultBadge = this.add.image(0, 0, this._badgeName).setScale(this._scale);

    sizer.add(this._resultBadge, {
      key: 'battleroyale_badge',
      align: 'center-top',
      offsetX: 0,
      offsetY: 0,
      expand: false,
    });

    // Add Victory Title
    this._resultTitle = this.add.image(0, 0, this._badgeTitle).setScale(this._scale);

    sizer.add(this._resultTitle, {
      key: 'battleroyale_title',
      align: 'center-top',
      offsetX: this.applyScale(0),
      offsetY: this.applyScale(130),
      expand: false,
    });

    // Winner Name
    const winnerName = this._winner.playerName;
    this._winnerLabel = this.add.bitmapText(0, 0, 'cc_outline', winnerName, this.applyScale(28), 1).setCharacterTint(
      //message.indexOf(player1),
      this.getTintIndex(this._winner.playerName, winnerName, false),
      this._winner.playerName.length,
      true,
      this.getTintColor(this._winner.playerName),
    );

    sizer.add(this._winnerLabel, {
      key: 'winner-name',
      align: 'center-top',
      offsetX: 0,
      offsetY: this.applyScale(270),
      expand: false,
    });

    // Player PFP
    var imageData = new Phaser.GameObjects.Image(this, 0, 0, this._winner.playerImageKey);
    var imageWidth = imageData.width;

    const rectConfig = {
      maskType: 'roundRectangle',
      radius: Math.ceil(imageWidth / 8),
    };

    this._winnerPFP = this.add.rexCircleMaskImage(0, 0, this._winner.playerImageKey, '', rectConfig);
    this._winnerPFP.displayHeight = this.applyScale(149);
    this._winnerPFP.scaleX = this._winnerPFP.scaleY;
    imageData.destroy();

    sizer.add(this._winnerPFP, {
      key: 'battleroyale_pfp',
      align: 'center-top',
      offsetX: 0,
      offsetY: this.applyScale(330),
      expand: false,
    });

    // Text
    this._text = this.add.bitmapText(0, 0, 'cc_outline', 'is the Winner', this.applyScale(28), 1);

    sizer.add(this._text, {
      key: 'battleroyale-text',
      align: 'center-top',
      offsetX: 0,
      offsetY: this.applyScale(520),
      expand: false,
    });

    // Add Return Home Button
    this._returnHomeButton = new Button(this, 0, 0, 'bossfight_victory_return_home_button', true, 1.05).setScale(this._scale);

    this._returnHomeButton.onClick().subscribe(pointer => {
      this.destroy();
    });

    this.add.existing(this._returnHomeButton);

    sizer.add(this._returnHomeButton, {
      key: 'return-home-button',
      align: 'left-bottom',
      offsetX: 0,
      offsetY: 0,
      expand: false,
    });

    // Add View Results Button
    this._viewResultsButton = new Button(this, 0, 0, 'battleroyale_view_results_button', true, 1.05).setScale(this._scale);

    this._viewResultsButton.onClick().subscribe(pointer => {
      this.unloadAssets();
      this.scene.launch('BattleRoyaleResultsScene', {
        participants: this._participants,
      });
      this.scene.stop('BattleRoyaleScene');
      this.scene.stop();
    });

    this.add.existing(this._viewResultsButton);

    sizer.add(this._viewResultsButton, {
      key: 'view-results-button',
      align: 'left-bottom',
      offsetX: this.applyScale(210),
      offsetY: 0,
      expand: false,
    });

    sizer.layout();
  }

  applyScale(length) {
    return length * this._scale;
  }

  private destroy() {
    this.unloadAssets();
    this.scene.start('HomebaseScene');
    this.scene.stop('BattleRoyaleScene');
    this.scene.stop();
  }

  private getWinner(participants: any) {
    var winner = undefined;
    participants.forEach(participant => {
      if ((participant.placing as number) == 1) {
        winner = participant;
      }
    });
    return winner;
  }

  getTintColor(name: string) {
    return name === UserService.getInstance().getUserName() ? 0xdea827 : 0x2fe2a2;
  }

  getTintIndex(name: string, message: string, last: boolean) {
    var index = last ? message.lastIndexOf(name) : message.indexOf(name);
    if (index == 0 || index < 59) {
      return index;
    } else {
      return index - 1;
    }
  }

  unloadAssets() {
    UnloadImages(this, Object.keys(BR_GameOver_Scene_Assets));

    // Unloads winning player pfp
    this.textures.remove(this._winner.playerImageKey);
  }
}
